module.exports = __webpack_public_path__ + "img/mr_head_1ic1.33fab367.jpg";